(function() {
  'use strict';

  angular.module('quiz.quizCtrl', [
    'quiz.multipleChoice',
    'quiz.trueFalse',
    'quiz.sequence',
    'quiz.multipleCorrect',
    'quiz.quizIntro',
    'quiz.quizOutro',
    'quiz.labelingPicture',
    'quiz.labelingItemsInPicture',
    'service.quizFactory',
    'factories.durationTrackingFactory'
  ]).controller('QuizCtrl', QuizCtrl);

  QuizCtrl.$inject = [
    '$scope',
    '$timeout',
    'QuizServiceFactory',
    'DurationTrackingFactory',
    '$rootScope',
    'Navigation',
    'gettext',
    'ContentPlayerService'
  ];

  function QuizCtrl($scope, $timeout, QuizServiceFactory, DurationTrackingFactory, $rootScope, Navigation,
                    gettext, ContentPlayerService) {
    var navigation;
    var QuizService;
    var progressStatusWatcher;

    var viewMapping = {
      DTOQuestionMultipleChoice: 'quiz/multipleChoice.html',
      DTOQuestionTrueFalse: 'quiz/trueFalse.html',
      DTOQuestionSequence: 'quiz/seq/sequence.html',
      DTOQuestionMultipleCorrect: 'quiz/multipleCorrect.html',
      DTOQuestionImageParts: 'quiz/lip/lip.html',
      DTOQuestionImageCaption: 'quiz/lp/labelingPicture.html'
    };

    var incompleteImageMap = {
      DTOQuestionMultipleChoice: 'incomplete_question_MC.png',
      DTOQuestionSequence: 'incomplete_question_Sequencing.png',
      DTOQuestionMultipleCorrect: 'incomplete_question_MS.png',
      DTOQuestionImageCaption: 'incomplete_question_LP.png',
      DTOQuestionTrueFalse: 'incomplete_question_TF.png',
      DTOQuestionImageParts: 'incomplete_question_LIP.png'
    };

    // translate from DB
    gettext('Label each picture below.');
    gettext('Place the following items into the correct order.');
    gettext('Label each item in the picture below.');

    $scope.questionContentClass = '';
    $scope.quizSrc = '';
    $scope.incompleteImgSrc = '';

    $scope.state = {
      name: 'ready',
      tryAgainEnabled: false,
      tryAgainRequested: false,
      answerSubmitted: false,
      showAnswersEnabled: false,
      feedback: '',
      showAnswersRequested: false,
      answerSelected: false,
      answerGraded: false,
      triesText: ''
    };

    navigation = $scope.navigation;
    QuizService = QuizServiceFactory.getQuizService(navigation.isPreview);

    navigation.intercept('canNavigate', function interceptCanNavigate(navigateTo) {
      if (navigateTo === navigation.directions.previous) {
        return !($scope.state.name === 'processing');
      }

      return navigateTo !== navigation.directions.next || $scope.state.answerGraded || navigation.freeNavigation;
    });

    $scope.leftArrowClass = function() {
      return 'previousQuestionEnabled';
    };

    $scope.rightArrowClass = function() {
      return $scope.state.answerGraded || navigation.freeNavigation ? 'nextQuestionEnabled' : 'nextQuestionDisabled';
    };

    $scope.requestPreviousSlide = navigation.navigatePrevious;
    $scope.requestNextSlide = navigation.navigateNext;

    // child slide controllers will set this
    $scope.answer = {
      selectedAnswer: null
    };

    progressStatusWatcher = $scope.$on('$progressProcessingCompleted', quizReady);

    function quizReady() {
      if (!_.isEmpty(ContentPlayerService.serviceStatus)) {
        return;
      }

      progressStatusWatcher();
    }

    function setup() {
      var quizId;

      if (!$scope.currentSlide || $scope.currentSlide.__type !== 'QuizQuestionSlideInfo') {
        return;
      }

      quizReady();

      $scope.question = $scope.currentSlide.question;

      quizId = $scope.currentSlide.quizId;
      $scope.amountOfQuestions = $scope.quizIdAmountOfQuestions[quizId].total;

      $scope.quizSrc = $scope.question.isValid ? viewMapping[$scope.question.__type] : null;

      if (!$scope.question.isValid) {
        setIncompleteImgSrc();
      }

      $rootScope.questionStyle = $scope.question.__type;
      $scope.quizCompleted = $scope.currentSlide.quizCompleted;
      $scope.questionAnswers = [];

      if ($scope.question.answers) {
        $scope.questionAnswers = $scope.question.answers.concat($scope.question.extraAnswers || []);
      } else if ($scope.question.options) {
        $scope.questionAnswers = $scope.question.options.concat();
      } else if ($scope.question.captions) {
        $scope.questionAnswers = $scope.question.captions.concat();
      }

      // prepare items for QA Selenium
      if ($scope.questionAnswers.length > 0) {
        $scope.questionAnswers = _.map($scope.questionAnswers, function(item) {
          var answer = item.answer;
          if (answer) {
            item.$id = answer.substring(0, 50).replace(/\s+/g, '')
              .toLowerCase();
          }

          return item;
        });
      }

      $scope.questionImages = [];
      if ($scope.question.images) {
        $scope.questionImages = $scope.question.images.concat();
      }

      setInitialState();

      $timeout(function() {
        // let DOM update with quiz resized before we show it to the user
        Navigation.state = Navigation.states.ready;
        Navigation.showNavControls = true;
      }, 250);
    }

    setup();

    $scope.submitAnswer = function() {
      var frameDuration;
      var slide;
      var answer;

      if (!canSubmitAnswer()) {
        return false;
      }

      setProcessingState();

      frameDuration = DurationTrackingFactory.getFrameDuration($scope.currentSlide.id);
      DurationTrackingFactory.cleanFrameDuration($scope.currentSlide.id);

      $scope.currentSlide.durationMilliseconds = frameDuration ? frameDuration.durationMilliseconds : 0;

      slide = _.clone($scope.currentSlide);

      answer = {
        quizId: $scope.currentSlide.quizId.toString(),
        questionId: $scope.question.id.toString(),
        slide: slide,
        answer: $scope.answer.selectedAnswer
      };

      $scope.question.selectedAnswer = $scope.answer.selectedAnswer;
      $scope.clearStoredSelectedAnswer();

      answer.cModuleId = $scope.cModuleId;
      answer.courseId = $scope.courseId;
      QuizService.answerQuestion(answer, answerQuestionSuccess, answerQuestionError);
    };

    function answerQuestionSuccess(result) {
      // TODO: deprecate - remove when .NET player backend is removed
      if (result.frameIsStale) {
        return $scope.onStaleFrameFound();
      }

      $scope.quizIdAmountOfQuestions[$scope.currentSlide.quizId].completed++;
      $scope.currentSlide.numPoints = result.numPoints;
      $scope.currentSlide.numAttempts = result.numAttempts;
      $scope.question.numberCorrect = result.numberCorrect;
      $scope.question.numberIncorrect = result.numberIncorrect;
      $scope.quizCompleted = result.quizCompleted;
      $scope.question.answerIsCorrect = result.answerIsCorrect;
      $scope.question.correctAnswer = result.correctAnswer;
      $scope.question.correctAnswerList = result.correctAnswerList;
      $scope.question.attemptsAllowed = result.attemptsAllowed;
      $scope.currentSlide.hasAnswer = result.hasAnswer;
      $scope.question.showAnswerEnabled = result.showAnswerEnabled;
      $scope.question.gradedOptionIndices = result.gradedOptionIndices;

      if (result.quizLastSlideInfo) {
        $scope.setQuizLastSlideInfo(result.quizLastSlideInfo);
      }

      // TODO: deprecate - remove when .NET player backend is removed
      if (result.completionInfo) {
        $scope.setCompletionInfo(result.completionInfo);
      }

      if (result.quizCompleted) {
        $scope.markQuizComplete($scope.currentSlide.quizId);
      }

      setGradedState();
    }

    function answerQuestionError(error) {
      if (error && error.data === 'ContentModified') {
        $scope.onStaleFrameFound();
        return true;
      }
    }

    function canSubmitAnswer() {
      if ($scope.state.name === 'processing' || !$scope.state.answerSelected) {
        return false;
      }

      return !($scope.state.answerGraded && !$scope.state.tryAgainEnabled);
    }

    function setInitialState() {
      var storedAnswer;

      if ($scope.currentSlide.hasAnswer) {
        $scope.answer.selectedAnswer = $scope.question.selectedAnswer;
        setGradedState();
        return;
      }

      storedAnswer = $scope.quizAnswerStorage.getQuestionAnswer($scope.question.id);

      // do not load saved answers for a question modified by a trainer
      if (storedAnswer && storedAnswer.modified !== $scope.currentSlide.questionModifiedTimestamp) {
        $scope.quizAnswerStorage.clearQuestionAnswer($scope.question.id);
        storedAnswer = null;
      }

      if (storedAnswer) {
        storedAnswer = storedAnswer.answer;
      }

      $scope.answer.selectedAnswer = storedAnswer;

      $scope.state = {
        name: 'ready',
        tryAgainEnabled: false,
        tryAgainRequested: false,
        answerSubmitted: false,
        showAnswersEnabled: false,
        feedback: '',
        showAnswersRequested: false,
        answerSelected: storedAnswer !== null,
        answerGraded: false,
        triesText: getTriesText()
      };
    }

    function setProcessingState() {
      $scope.state.answerSubmitted = true;
      $scope.state.name = 'processing';
    }

    function setGradedState() {
      var newState = {
        answerSubmitted: true,
        showAnswersEnabled: false,
        feedback: '',
        showAnswersRequested: false,
        answerSelected: true,
        name: 'answerCorrect',
        tryAgainEnabled: false,
        tryAgainRequested: false,
        answerGraded: true,
        triesText: ''
      };
      var isMultipleTriesQuestion;

      if (!$scope.question.answerIsCorrect) {
        isMultipleTriesQuestion = $scope.question.attemptsAllowed > 1 || $scope.question.attemptsAllowed === -1;

        if (isMultipleTriesQuestion) {
          newState.triesText = $scope.state.triesText;
        }

        if ($scope.question.numberCorrect > 0) {
          newState.name = 'answerPartialcorrect';
        } else {
          newState.name = 'answerIncorrect';
        }

        if ($scope.quizCompleted) {
          newState.tryAgainEnabled = false;
        } else if ($scope.question.attemptsAllowed === -1) {
          // unlimited tries
          newState.tryAgainEnabled = true;
        } else {
          newState.tryAgainEnabled = $scope.currentSlide.numAttempts < $scope.question.attemptsAllowed;
        }

        if (!newState.tryAgainEnabled) {
          newState.showAnswersEnabled = $scope.question.showAnswerEnabled;
          newState.feedback = $scope.question.feedback;
        }
      } else if ($scope.question.answerIsCorrect) {
        newState.showAnswersEnabled = $scope.question.showAnswerEnabled;

        if (newState.showAnswersEnabled) {
          newState.showAnswersRequested = true;
          newState.feedback = $scope.question.feedback;
        }
      }

      $scope.state = newState;
    }

    function getTriesText() {
      if ($scope.question.attemptsAllowed < 0) {
        return gettext('Unlimited');
      }

      return ($scope.currentSlide.numAttempts + 1) + '/' + $scope.question.attemptsAllowed;
    }

    $scope.tryAgain = function() {
      $scope.quizIdAmountOfQuestions[$scope.currentSlide.quizId].completed--;
      $scope.clearStoredSelectedAnswer();
      $scope.answer.selectedAnswer = null;
      $scope.currentSlide.hasAnswer = false;

      $scope.state = {
        name: 'ready',
        tryAgainEnabled: false,
        tryAgainRequested: true,
        answerSubmitted: false,
        showAnswersEnabled: false,
        feedback: '',
        showAnswersRequested: false,
        answerSelected: false,
        answerGraded: false,
        triesText: getTriesText()
      };
    };

    $scope.storeSelectedAnswer = function() {
      $scope.quizAnswerStorage.setQuestionAnswer($scope.question.id, $scope.answer.selectedAnswer, $scope.currentSlide.questionModifiedTimestamp);
    };

    $scope.clearStoredSelectedAnswer = function() {
      $scope.quizAnswerStorage.clearQuestionAnswer($scope.question.id);
    };

    $scope.actionBtn = {
      txt: '',
      clazz: ''
    };

    $scope.$watch(function setActionButton() {
      var obj;

      if (!_.isEmpty(ContentPlayerService.serviceStatus)) {
        return;
      }

      obj = {
        txt: '',
        clazz: ''
      };

      if ($scope.state.name === 'processing') {
        obj.txt = 'Submit';
        obj.clazz = 'btn-primary disabled';
      } else if ($scope.state.showAnswersEnabled && !$scope.question.answerIsCorrect) {
        obj.txt = 'Answers';
        obj.clazz = 'btn-default ' + ($scope.state.showAnswersRequested ? 'active' : '');
      } else if (!$scope.state.answerSubmitted && $scope.state.answerSelected) {
        obj.txt = 'Submit';
        obj.clazz = 'btn-primary';
      } else if ($scope.state.tryAgainEnabled) {
        obj.txt = 'Try Again';
        obj.clazz = 'btn-default';
      } else {
        obj.txt = '';
      }

      if (obj.txt === $scope.actionBtn.txt && obj.clazz === $scope.actionBtn.clazz) {
        return;
      }

      $scope.actionBtn.txt = obj.txt;
      $scope.actionBtn.clazz = obj.clazz;
    });

    $scope.onActionButtonClick = function() {
      if ($scope.state.showAnswersEnabled) {
        $scope.state.showAnswersRequested = !$scope.state.showAnswersRequested;
        return;
      }

      if ($scope.state.answerSelected && !$scope.state.answerSubmitted) {
        return $scope.submitAnswer();
      }

      if ($scope.state.tryAgainEnabled) {
        return $scope.tryAgain();
      }
    };

    $scope.triesSubareaClass = function() {
      return $scope.state.triesText === '' ? 'triesSubareaDisabled' : 'triesSubarea';
    };

    function setIncompleteImgSrc() {
      $scope.incompleteImgSrc = 'images/' + incompleteImageMap[$scope.question.__type];
    }
  }
})();
